import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { PUBLIC_API_BASE_URL } from '../../../config/env';
import { buildUpdateUrl } from '../slugify';
import { getReadIds } from '../readTracking';

/* 인트로 하단 업데이트 게시판 - 로그인 없이도 보이는 공개 글 목록(/public/updates).
   관리자에서 발행한 글만 최신순으로 노출된다. 각 글은 실제 <a href="/update/:id">로
   연결해서 검색엔진이 개별 페이지(UpdatePost.jsx)를 링크 따라 발견/색인하게 한다 -
   예전엔 여기서 접었다펼쳤다(details)로 본문까지 바로 보여줬는데, 그러면 글마다 고유
   URL이 없어 검색결과에 개별로 안 뜬다(2026-08-28, "상위노출 여러 방면으로" 요청으로
   개별 페이지 도입하며 단순 목록으로 정리). */

const formatDate = iso => (iso ? String(iso).slice(0, 10) : '');

const NoticeBoard = () => {
    const [items, setItems] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [readIds, setReadIds] = useState(() => getReadIds());

    useEffect(() => {
        let cancelled = false;
        axios
            .get(`${PUBLIC_API_BASE_URL}/public/updates`, { params: { limit: 5 } })
            .then(({ data }) => {
                if (!cancelled) {
                    setItems(data.list || []);
                    setReadIds(getReadIds());
                }
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setLoaded(true);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (loaded && items.length === 0) return null;

    return (
        <section className="intro-board-clean">
            <div className="ifc-container">
                <div className="intro-section-head-clean">
                    <h2 className="intro-section-title">업데이트 소식</h2>
                    <p className="intro-section-sub">
                        매일 확인하는 순위 변동과 노출 현황을 공유합니다.
                    </p>
                </div>
                <div className="intro-board-list">
                    {items.map(item => (
                        <Link key={item.id} to={buildUpdateUrl(item)} className="intro-board-item">
                            <span className="intro-board-title">
                                {readIds.has(String(item.id)) && (
                                    <span className="intro-board-read-badge">확인함</span>
                                )}
                                {item.title}
                            </span>
                            <span className="intro-board-date">{formatDate(item.created_at)}</span>
                        </Link>
                    ))}
                </div>
                <div style={{ textAlign: 'center', marginTop: 24 }}>
                    <Link to="/updates" className="intro-board-more">
                        업데이트 소식 전체보기
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default NoticeBoard;
